import { autoserialize } from 'cerialize';

import { Pricing } from './pricing';

export class Invoice {
  @autoserialize created_at?: string;
  @autoserialize status?: string;
  @autoserialize number?: string;
  @autoserialize total?: number;
  @autoserialize payment_method_type?: string;
  @autoserialize transfer_amount?: number;
  @autoserialize hosted_invoice_url?: string;

  constructor(payload?: IInvoice) {
    this.created_at = payload?.created_at;
    this.status = payload?.status;
    this.number = payload?.number;
    this.total = payload?.total;
    this.payment_method_type = payload?.payment_method_type;
    this.transfer_amount = payload?.transfer_amount;
    this.hosted_invoice_url = payload?.hosted_invoice_url;
  }

  public static OnSerialized(instance: Invoice, json: any): void {
    json.total = json.total !== null ? Pricing.formatPrice(json.total * 100) : null;
    json.transfer_amount = json.transfer_amount !== null ? Pricing.formatPrice(json.transfer_amount * 100) : null;
  }

  public static OnDeserialized(instance: Invoice): void {
    instance.total = instance.total !== null ? Pricing.formatPrice(instance.total / 100) : null;
    instance.transfer_amount = instance.transfer_amount !== null ? Pricing.formatPrice(instance.transfer_amount / 100) : null;
  }
}

export interface IInvoice {
  created_at?: string;
  status?: string;
  number?: string;
  total?: number;
  payment_method_type?: string;
  transfer_amount?: number;
  hosted_invoice_url?: string;
}
